module.exports = __webpack_public_path__ + "img/yq-pic7.203efbee.png";